// ** React Imports
import React, { useState, forwardRef, Fragment } from 'react'

// ** MUI Imports
import Box from '@mui/material/Box'
import TextField from '@mui/material/TextField'
import Typography from '@mui/material/Typography'
import Button from '@mui/material/Button'

// ** Third Party Imports
import format from 'date-fns/format'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import DatePickerWrapper from 'core/styles/libs/react-datepicker'

// Redux and router hooks are no longer needed here
// import { useParams } from 'react-router-dom'
// import { useDispatch } from 'react-redux'
// import { getCustomerInvoice } from 'store/customers'

const PickersRange = props => {
  // ** Props
  // Destructure onApply, which will be passed down from SelectFilter
  const { setOpenDatePicker, onApply } = props

  // ** States
  const [endDate, setEndDate] = useState(new Date())
  const [startDate, setStartDate] = useState(new Date())

  // eslint-disable-next-line react/display-name
  const CustomInput = forwardRef((props, ref) => {
    const formattedDate =
      props.start || props.end ? format(props.start || props.end, 'MM/dd/yyyy') : ''

    return (
      <TextField
        inputRef={ref}
        {...props}
        value={formattedDate}
        size='small'
        variant='standard'
        sx={{ fontSize: '0.875rem' }}
      />
    )
  })

  const submitFilterHandler = () => {
    // Instead of dispatching, call the onApply function from props
    // with the selected start and end dates.
    if (onApply) {
      onApply(startDate, endDate)
    }

    // The onApply function in the parent will handle closing the date picker
  }

  // Helper functions for min/max dates to avoid direct mutation
  const getMinDate = d => {
    if (!d) return null
    const newDate = new Date(d)
    newDate.setDate(d.getDate() + 1)
    return newDate
  }

  const getMaxDate = d => {
    if (!d) return null
    const newDate = new Date(d)
    newDate.setDate(d.getDate() - 1)
    return newDate
  }

  return (
    <Fragment>
      <DatePickerWrapper>
        <Typography sx={{ mb: 5 }}>Custom</Typography>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <DatePicker
            selectsStart
            endDate={endDate}
            selected={startDate}
            startDate={startDate}
            maxDate={getMaxDate(endDate)}
            onChange={date => setStartDate(date)}
            shouldCloseOnSelect={true}
            customInput={<CustomInput start={startDate} />}
          />
          <Typography sx={{ fontSize: '1.25rem', mx: 2 }}>-</Typography>
          <DatePicker
            selectsEnd
            endDate={endDate}
            selected={endDate}
            startDate={startDate}
            minDate={getMinDate(startDate)}
            onChange={date => setEndDate(date)}
            shouldCloseOnSelect={true}
            customInput={<CustomInput end={endDate} />}
          />
        </Box>
      </DatePickerWrapper>
      <Box sx={{ textAlign: 'end', marginTop: '1rem' }}>
        <Button sx={{ color: 'common.blue', fontWeight: 600 }} onClick={() => setOpenDatePicker(false)}>
          Cancel
        </Button>
        <Button sx={{ color: 'common.blue', fontWeight: 600 }} onClick={submitFilterHandler}>
          Apply
        </Button>
      </Box>
    </Fragment>
  )
}

export default PickersRange